import { createSlice } from '@reduxjs/toolkit';

// create slice

const name = 'sidePanel';
const initialState = createInitialState();
const reducers = createReducers();
const slice = createSlice({ name, initialState, reducers });

// exports

export const sidePanelActions = { ...slice.actions };
export const sidePanelReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        isOpen: false,
        data: null,
        type: null,
    };
}

function createReducers() {
    return {
        openPanel,
        closePanel,
    };

    function openPanel(state, action) {
        state.isOpen = true;
        state.data = action.payload.data;
        state.type = action.payload.type;
    }

    function closePanel(state) {
        state.isOpen = false;
        state.data = null;
        state.type = null;
    }
}
